import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function SvgComponent() {
  return /*#__PURE__*/React.createElement(Svg, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M0.833687 8.13191C0.567436 7.8146 0.608824 7.34153 0.92613 7.07528L5.3617 3.3534C5.73346 3.04145 6.27552 3.04146 6.64728 3.3534L11.0829 7.07535C11.4002 7.34161 11.4416 7.81467 11.1753 8.13198C10.9091 8.44928 10.436 8.49067 10.1187 8.22442L6.32588 5.04183C6.14 4.88586 5.86897 4.88586 5.68309 5.04183L1.89031 8.22435C1.57301 8.4906 1.09994 8.44921 0.833687 8.13191Z",
    fill: "black",
    fillOpacity: "0.54",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}
export default SvgComponent;